import React from 'react'
import RatingTable from "./components/Table/RatingTable";

const Ratings = () => {
  return (
    <div>
      <RatingTable/>
    </div>
  )
}

export default Ratings